import { Combobox, ComboboxInput, ComboboxPopupContainer } from "@angular/aria/combobox";
import { Listbox, Option } from "@angular/aria/listbox";
import { AsyncPipe, CommonModule } from "@angular/common";
import { Component, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Kasse } from "../../../Api/DcoApi/Kasse";
import { SearchAndSelectDropDownBase } from "./SearchAndSelectDropDownBase";
import { OverlayModule } from '@angular/cdk/overlay';
import { NgbTypeahead } from '@ng-bootstrap/ng-bootstrap/typeahead';

@Component({
  imports: [
    Combobox,
    ComboboxInput,
    ComboboxPopupContainer,
    Listbox,
    Option,
    OverlayModule,
    FormsModule,
    AsyncPipe,
    CommonModule,
    NgbTypeahead
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'KassenSelect',
  templateUrl: './KassenSelect.html',
  standalone: true,
  styleUrl: './KassenSelect.css'
})
export class KassenSelect extends SearchAndSelectDropDownBase<Kasse> {
  override formatter: (obj: Kasse) => string = obj => `${obj.name} ${obj.ik}`;
  protected override LoadData(): Promise<Kasse[]> {
    return this.Client.Get<Kasse[]>('/Backend/Api/V2/Kassen');
  }
  protected override Serach(querry: string): Kasse[] {
    return this.Data.filter(g => querry == '' || (g.name?.toLowerCase().includes(querry?.toLowerCase()) || g.ik?.toLowerCase().includes(querry?.toLowerCase())));
  }

}
